import { render, staticRenderFns } from "./ServePrice.vue?vue&type=template&id=4ca5f232&"
import script from "./ServePrice.vue?vue&type=script&lang=js&"
export * from "./ServePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports